import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

type Data = {
  sellerId: string
  productId: string
  discountPercent: number
  additionPercent: number
}

type Output = {
  data: string
}

const loadOrderProductCommission = (data: Data): Promise<Output> => {
  return axios.get(`/orders/products/${data.productId}/commission`, {
    params: data
  })
}

export function useLoadOrderProductCommission(query: Data) {
  return useQuery(
    ['orderProductCommission', query],
    () => loadOrderProductCommission(query),
    {
      enabled:
        !!query.sellerId &&
        !!query.productId &&
        query.discountPercent >= 0 &&
        query.additionPercent >= 0,

      onError: () =>
        toast.error('Não foi possível carregar a comissão do produto!', {
          toastId: 'orderProductCommission'
        })
    }
  )
}
